import moment from 'jalali-moment';

const convertJalaiToMiladi = (date) => {
  const miladiDate = moment.from(date, 'fa', 'YYYY-M-D').format('YYYY/MM/DD');
  return miladiDate;
};

export { convertJalaiToMiladi };
